import InfoCircleIcon from '@/common/assets/icons/infoCircleIcon.svg?react';
import InquiryForm from '@/common/components/base/inquiryPlate/forms/InquiryForm';
import ResultOfInquiryModal from '@/common/components/base/inquiryPlate/modals/ResultOfInquiryModal';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import { InquiryPlateResultType } from '@/common/queries/inquiryPlate/inquiryPlateQuery.type';
import { useState } from 'react';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

export default ({
  closeModal,
  open,
  fileId,
  fetchedResultHandler,
}: MainModalProps & {
  fileId: string | null;
  fetchedResultHandler: (input: InquiryPlateResultType) => void;
}) => {
  return (
    <MainModal
      childrenWrapperClassName={css({ px: '16px' })}
      open={open}
      closeModal={closeModal}
    >
      <InquiryWithPlateModal
        fetchedResultHandler={fetchedResultHandler}
        fileId={fileId}
        onCloseModal={closeModal}
      />
    </MainModal>
  );
};

const InquiryWithPlateModal = ({
  onCloseModal,
  fileId,
  fetchedResultHandler,
}: {
  onCloseModal: () => void;
  fileId: string | null;
  fetchedResultHandler: (input: InquiryPlateResultType) => void;
}) => {
  const [fetchedData, setFetchedData] = useState<InquiryPlateResultType | null>(
    null,
  );
  return fetchedData ? (
    <ResultOfInquiryModal
      ResultHandler={fetchedResultHandler}
      onCloseModal={onCloseModal}
      data={fetchedData!}
    />
  ) : (
    <>
      <TitleDescription mb={24}>استعلام با پلاک خودرو</TitleDescription>
      <Box display="flex" flexDirection="column" mb={0} gap="16px">
        <Box
          className={css({
            display: 'flex',
            alignItems: 'start',
            gap: '4px',
          })}
        >
          <InfoCircleIcon
            width={32}
            height={32}
            color={token('colors.black-2')}
            className={css({
              position: 'relative',
              top: '2px',
            })}
          />
          <Typography>
            چنانچه پلاک خودروی شما منطقه آزاد است از طریق تکمیل فرم مشخصات خودرو
            بایستی اقدام کنید
          </Typography>
        </Box>
        <InquiryForm
          onFetchedInquiredPlate={(data) => setFetchedData(data)}
          onCloseModal={onCloseModal}
          id={fileId}
        />
      </Box>
    </>
  );
};
